import { makeStyles } from '@material-ui/core';

export const boxStyles = makeStyles({
  header: {
    fontSize: '16px',
  },
  hr: {
    color: '#D6CFCF',
  },
  content: {
    paddingRight: '10px !important',
    paddingBottom: '10px !important',
  },
  contentGrid: {
    minHeight: '60px',
  },
  title: {
    whiteSpace: 'nowrap',
  },
  subtitle: {
    fontSize: '12px',
  },
  tooltip: {
    maxWidth: 'none',
    fontSize: '12px',
  },
  visualizarDados: {
    fontWeight: 'bold',
  },
});

export const periodoStyles = makeStyles({
  periodoFixo: {
    width: 105,
    height: 20,
    backgroundColor: process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#5C5E87' : '#3DA4BC',
    color: '#FFF',
    borderRadius: 5,
    fontSize: 12,
    paddingLeft: '15px',
  },
  formControlSelect: {
    width: 105,
    height: 20,
    backgroundColor: process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#5C5E87' : '#3DA4BC',
    color: '#FFF',
    borderRadius: 5,
  },
  select: {
    color: '#FFF',
    fontSize: 12,
    height: 20,
    '&:after': {
      borderBottomColor: '#FFF',
    },
    '& .MuiSvgIcon-root': {
      color: '#FFF',
    },
  },
  options: {
    color: '#FFF',
    fontSize: 12,
    height: 20,
    backgroundColor:
      process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#5C5E87 !important' : '#3DA4BC !important',
    '&:hover': {
      background:
        process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#5C5E87 !important' : '#3DA4BC !important',
    },
  },
});

export const dashboardTabStyles = makeStyles({
  root: {
    backgroundColor: process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#171B54' : '#3DA4BC',
    color: '#FFF',
  },
  valorVendas: {
    marginTop: '20px',
  },
  trendingUp: {
    color: process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#7DB545' : '#85EA20',
  },
  trendingDown: {
    color: '#ED5258',
  },
  evolucao: {
    lineHeight: '0px',
  },
  tabIndicator: {
    color: '#22D3EE',
    backgroundColor: '#22D3EE',
  },
  graficoLine: {
    marginBottom: '10px',
  },
  evolucaoVenda: {
    fontSize: '10px',
    marginTop: '-10px',
  },
  headerEvolucaoVendas: {
    display: 'inline-block',
    marginLeft: '10px',
  },
});
